module.exports = __webpack_public_path__ + "img/4.f36e362f.jpg";